import { render, staticRenderFns } from "./Wallboxes.vue?vue&type=template&id=074454fd&scoped=true"
import script from "./Wallboxes.vue?vue&type=script&lang=js"
export * from "./Wallboxes.vue?vue&type=script&lang=js"
import style0 from "./Wallboxes.vue?vue&type=style&index=0&id=074454fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074454fd",
  null
  
)

export default component.exports